import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/no-data/table-empty.png';
const _hoisted_1 = {
  class: "category-page common-page"
};
const _hoisted_2 = {
  class: "page-title"
};
const _hoisted_3 = {
  class: "search"
};
const _hoisted_4 = {
  class: "search-form"
};
const _hoisted_5 = {
  class: "ingred-list"
};
import { reactive, ref, onMounted } from "vue";
import { addLoading } from "@/utils/element-method";
import { ElMessage, ElMessageBox } from "element-plus";
import ingredDialog from "./components/ingred-dialog.vue";
import recommendDialog from "./components/recommend-dialog.vue";
import { getIngredListPage, deleteIngred, deleteIngredBatch, importComponent } from "@/service/modules/scan";
import protoPagination from "@/components/proto-pagination.vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'ingred',
  setup(__props) {
    const ingredList = ref([]);
    const selectedIngreds = ref([]);
    const ingredDialogVisible = ref(false);
    const ingredDialogType = ref("add");
    const ingredData = ref({});
    const page = reactive({
      current: 1,
      size: 10
    });
    const total = ref(0);
    const form = reactive({
      name: ""
    });
    function handleClearCaseList() {
      form.name = "";
      page.current = 1;
      getIngredList();
    }
    function restCaseList() {
      getIngredList();
    }
    // 处理表格选择变化
    function handleSelectionChange(selection) {
      selectedIngreds.value = selection;
    }
    // 批量删除
    function handleDeleteBatch() {
      if (selectedIngreds.value.length === 0) {
        ElMessage.warning("请选择要删除的成分");
        return;
      }
      ElMessageBox.confirm(`确定删除选中的 ${selectedIngreds.value.length} 个成分吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        try {
          const ids = selectedIngreds.value.map(ingred => ingred.id);
          await deleteIngredBatch(ids);
          ElMessage.success("批量删除成功");
          selectedIngreds.value = [];
          getIngredList();
        } catch (error) {
          console.error("批量删除失败", error);
          ElMessage.error("批量删除失败");
        }
      }).catch(() => {
        // 用户点击取消按钮时，不做任何操作
      });
    }
    const recommendDialogVisible = ref(false);
    const currentIngredData = ref({});
    const forbiddenDialogVisible = ref(false);
    const currentForbiddenData = ref({});
    // 表格引用
    const tableRef = ref(null);
    onMounted(() => {
      getIngredList();
    });
    getIngredList();
    async function getIngredList() {
      try {
        let res = await getIngredListPage({
          ...page,
          ...form
        });
        ingredList.value = res.data.records;
        total.value = Number(res.data.total);
        console.log("获取到的数据总数:", total.value);
      } catch (error) {
        console.log(error);
      }
    }
    function handlIngredTableCurrentChange(val) {
      page.current = val;
      getIngredList();
    }
    function handleUserTableSizeChange(val) {
      page.size = val;
      getIngredList();
    }
    function handleDelete(id) {
      ElMessageBox.confirm("确定删除该成分吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        await deleteIngred(id);
        ElMessage.success("删除成功");
        getIngredList();
      }).catch(() => {
        // 用户点击取消按钮时，不做任何操作
        // 或者可以添加一些提示信息
      });
    }
    function handleUpdate(item) {
      ingredDialogType.value = "edit";
      ingredData.value = item;
      ingredDialogVisible.value = true;
    }
    function handleOpenItemDialog() {
      ingredDialogType.value = "add";
      ingredData.value = {};
      ingredDialogVisible.value = true;
    }
    function handleCloseItemDialog() {
      ingredDialogType.value = "add";
      ingredData.value = {};
      ingredDialogVisible.value = false;
      getIngredList(); // 关闭对话框后刷新列表
    }
    function handleRecommend(row) {
      currentIngredData.value = row;
      recommendDialogVisible.value = true;
    }
    function handleCloseRecommendDialog() {
      recommendDialogVisible.value = false;
      currentIngredData.value = {};
      getIngredList();
    }
    function handleForbidden(row) {
      currentForbiddenData.value = row;
      forbiddenDialogVisible.value = true;
    }
    function handleCloseForbiddenDialog() {
      forbiddenDialogVisible.value = false;
      currentForbiddenData.value = {};
    }
    function handleImport() {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = ".xlsx,.xls,.csv";
      input.onchange = async event => {
        const file = event.target.files?.[0];
        if (!file) return;
        const loading = addLoading();
        try {
          const formData = new FormData();
          formData.append("file", file);
          await importComponent(formData);
          ElMessage.success("导入成功");
          handleClearCaseList(); // 刷新列表
        } catch (error) {
          ElMessage.error("导入失败：" + error.message);
        } finally {
          loading.close(); // 无论成功还是失败，都关闭loading
        }
      };
      input.click();
    }
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[4] || (_cache[4] = _createTextVNode(" 成分管理 ")), _createVNode(_component_el_button, {
        type: "primary",
        style: {
          "margin-left": "5px"
        },
        onClick: handleOpenItemDialog
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("新增")])),
        _: 1
      }), _createVNode(_component_el_button, {
        onClick: handleDeleteBatch,
        type: "danger",
        style: {
          "margin-left": "5px"
        },
        disabled: selectedIngreds.value.length === 0
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("批量删除")])),
        _: 1
      }, 8, ["disabled"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_form, {
        inline: true,
        model: form,
        class: "demo-form-inline"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "名称",
          prop: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.name = $event),
            style: {
              "width": "180px"
            },
            placeholder: "请输入名称",
            clearable: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = $event => handleClearCaseList())
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("重置")])),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: restCaseList
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("搜索")])),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_table, {
        ref_key: "tableRef",
        ref: tableRef,
        data: ingredList.value,
        "header-cell-style": {
          background: '#F7F9FB !important',
          color: '#111111',
          height: '42px',
          fontSize: '14px'
        },
        style: {
          "width": "100%"
        },
        onSelectionChange: handleSelectionChange
      }, {
        empty: _withCtx(() => _cache[10] || (_cache[10] = [_createElementVNode("div", {
          class: "table-empty"
        }, [_createElementVNode("img", {
          class: "no-data",
          src: _imports_0,
          alt: ""
        }), _createElementVNode("div", {
          class: "empty-text"
        }, "暂无数据")], -1)])),
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          type: "selection",
          width: "55"
        }), _createVNode(_component_el_table_column, {
          label: "序号",
          "min-width": "70"
        }, {
          default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.$index + 1 + (page.current - 1) * page.size), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "name",
          label: "成分名称",
          "show-overflow-tooltip": "",
          "min-width": "180"
        }), _createVNode(_component_el_table_column, {
          prop: "recommendCount",
          label: "推荐商品数",
          "min-width": "120"
        }), _createVNode(_component_el_table_column, {
          prop: "introduction",
          label: "介绍",
          "show-overflow-tooltip": "",
          "min-width": "180"
        }), _createVNode(_component_el_table_column, {
          label: "操作",
          "min-width": "150",
          fixed: "right"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_link, {
            class: "m-r-10",
            type: "primary",
            onClick: $event => handleRecommend(scope.row)
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("推荐商品")])),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_link, {
            class: "m-r-10",
            type: "primary",
            onClick: $event => handleUpdate(scope.row)
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("编辑")])),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_link, {
            type: "danger",
            onClick: $event => handleDelete(scope.row.id)
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("删除")])),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]), _createVNode(protoPagination, {
        page: page,
        total: total.value,
        onSizeChange: handleUserTableSizeChange,
        onCurrentChange: handlIngredTableCurrentChange
      }, null, 8, ["page", "total"])])]), _createVNode(ingredDialog, {
        "dialog-visible": ingredDialogVisible.value,
        "dialog-type": ingredDialogType.value,
        "item-data": ingredData.value,
        onCloseDialog: handleCloseItemDialog
      }, null, 8, ["dialog-visible", "dialog-type", "item-data"]), _createVNode(recommendDialog, {
        "dialog-visible": recommendDialogVisible.value,
        "item-data": currentIngredData.value,
        onCloseDialog: handleCloseRecommendDialog,
        type: 2
      }, null, 8, ["dialog-visible", "item-data"])], 64);
    };
  }
});